export default __webpack_public_path__ + "static/media/lavender.cb2a6651.jpg";